import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 1.5rem 1.5rem 0 1.5rem;
  background: ${props => props.theme.cards.primary};
  border: 1px solid ${props => props.theme.cards.border};
  box-shadow: ${props => props.theme.shadows.primary};
  border-radius: ${props => props.theme.radius.primary};
  height: 100%;
  overflow-x: hidden;
  min-height: 750px;

  > header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
    border-bottom: 1px solid ${props => props.theme.cards.border};
    padding: 0 0.5rem;
    padding-bottom: 1rem;
    margin-bottom: 1rem;

    > aside {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 0.5rem;

      > aside {
        > h1 {
          font-size: 3rem;
        }
      }

      > main {
        > p {
          font-size: 12px;

          &:first-child {
            font-weight: bold;
            text-transform: uppercase;
          }
        }
      }
    }

    > main {
      font-weight: bold;
      text-transform: uppercase;

      > p {
        font-size: 12px;
        text-transform: uppercase;
      }
    }
  }
`;

export const MainScrollContainer = styled.div`
  position: relative;
  height: 100%;
  overflow-y: auto;
  width: 100%;

  ::-webkit-scrollbar {
    width: 8px;
    width: 22px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 8px;
    border: 8px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 9999px;
    background-color: ${props => props.theme.colors.muted}50;
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  padding: 1.5rem;
  background: ${props => props.theme.cards.primary};
  border: 1px solid ${props => props.theme.cards.border};
  border-bottom: none;
  border-radius: ${props => props.theme.radius.primary} ${props => props.theme.radius.primary} 0 0;

  > aside {
    width: 100%;

    label {
      display: none;
    }

    input {
      background: transparent;
      border: 1px solid ${props => props.theme.cards.border};
      border-radius: 50px;
      padding: 0.75rem 4rem 0.75rem 1.75rem;

      ::placeholder {
        color: ${props => props.theme.colors.muted};
      }

      &:focus {
        background: ${props => props.theme.cards.tertiary};
        border: 1px solid ${props => props.theme.cards.border};
      }
    }
  }

  main {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 40%;

    > button {
      width: 100%;
      height: 50px;
      border: none;
      padding: 0.8rem;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50px;
      background: ${props => props.theme.colors.pink};
      color: #fff;
      cursor: pointer;
      transition: all 0.2s ease-in-out;
      font-weight: bold;
      margin-left: -3rem;
      width: -webkit-fill-available;
      text-transform: uppercase;
      z-index: 2;
      font-size: 11px;

      &:hover {
        background: ${props => props.theme.colors.pink};
      }
    }
  }
`;

interface ITaskProps {
  completed: boolean;
  className?: string;
}

export const Task = styled.div<ITaskProps>`
  width: 100%;
  padding: 1rem 0 1rem 0.25rem;
  border-radius: 4px;
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: overlay 0.3s ease-in-out;
  gap: 1rem;
  user-select: none;
  border-bottom: 1px solid ${props => props.theme.cards.border};
  font-size: 14px;
  font-weight: 600;

  &:last-child {
    border-bottom: none;
  }

  > main {
    display: flex;
    align-items: center;
    width: 100%;
    cursor: pointer;

    > label {
      display: flex;
      align-items: center;
      text-decoration: ${props => (props.completed ? 'line-through' : 'unset')};
      color: ${props =>
        props.completed ? props.theme.colors.muted : props.theme.colors.white};
      gap: 1rem;

      > input {
        cursor: pointer;
      }
    }
  }

  > aside {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.3rem;
    background: ${props => props.theme.colors.muted}30;
    border-radius: 50%;
    min-width: 40px !important;
    height: 40px !important;
    cursor: pointer;

    > div {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;

      > button {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        cursor: pointer;
        display: flex;
        background: transparent;
        border: none;
        z-index: 9;
        color: ${props => props.theme.colors.white};
      }
    }
  }
`;

export const NotTasks = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  gap: 0.5rem;
  margin-top: 2rem;
  padding: 0 2rem;

  > header {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 1rem;

    > div {
      display: flex;
      justify-content: center;
      align-items: center;
      background: ${props => props.theme.cards.tertiary};
      border-radius: 50%;
      padding: 1rem;

      > svg {
        color: ${props => props.theme.colors.primary};
      }
    }

    > h5 {
      color: ${props => props.theme.colors.white};
      font-size: 1rem;
      text-align: center;
    }
  }

  > main {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;

    > p {
      color: ${props => props.theme.colors.muted};
      font-size: .75rem;
    }
  }
`;

export const Footer = styled.footer`
  position: absolute;
  display: flex;
  flex-direction: row;
  align-items: center;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 1rem 0;
  gap: 0.5rem;
  z-index: 9;
  background: ${props => props.theme.cards.primary};
  border: 1px solid ${props => props.theme.cards.border};
  box-shadow: ${props => props.theme.shadows.primary};
  border-top: 1px solid ${props => props.theme.cards.border};
  border-radius: 0 0 ${props => props.theme.radius.primary} ${props => props.theme.radius.primary};

  > div {
    display: grid;
    align-items: center;
    grid-template-columns: 1fr 1fr 1fr;
    width: 100%;

    > div {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 0.5rem;
      justify-content: center;

      /* h5 {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        user-select: none;
        white-space: nowrap;
        cursor: pointer;
        font-size: 12px;
        transition: all 0.25s ease-in-out;
        flex-direction: column;
        text-transform: uppercase;

        &:hover {
          color: ${props => props.theme.colors.tertiary};
        }

        &.current {
          color: ${props => props.theme.colors.tertiary};
        }
      } */
    }

    > h5:nth-child(4) {
      display: flex;
      justify-content: flex-end;
    }
  }
`;

export const CheckListWrapper = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 30px auto;
  align-items: flex-start;
  justify-content: flex-start;
  user-select: none;
  //padding: 1.5rem;
  //padding: 1.5rem 1rem 6rem 1.5rem !important;
  background: ${props => props.theme.cards.primary};
  border: 1px solid ${props => props.theme.cards.border};
  border-radius: 0 0 ${props => props.theme.radius.primary} ${props => props.theme.radius.primary};
  width: 100%;
  height: 100%;
  gap: 0.25rem 0;

  display: flex;
  flex-direction: column;

  //min-height: 350px;
  min-height: 451px;
  max-height: 451px;
  overflow-y: scroll;

  ::-webkit-scrollbar {
    width: 8px;
    width: 22px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 8px;
    border: 8px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 9999px;
    background-color: ${props => props.theme.colors.muted}50;
  }
`;

export const TodoItemWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;

  > aside {
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    width: 100%;

    > label {
      color: ${props => props.theme.colors.white};
      position: relative;
      cursor: pointer;
      display: flex;
      align-items: center;
      width: fit-content;
      transition: color 0.3s ease;
      margin-right: 20px;
      user-select: none;
      width: 100%;
      padding: .5rem 0;
    }
  
    > label::before,
    > label::after {
      content: '';
      position: absolute;
    }
  
    > label::before {
      height: 2px;
      width: 8px;
      left: -27px;
      background: ${props => props.theme.colors.tertiary};
      border-radius: 2px;
      transition: background 0.3s ease;
    }
  
    > label:after {
      height: 4px;
      width: 4px;
      top: 8px;
      left: -25px;
      border-radius: 50%;
    }
  
    > input[type='checkbox'] {
      -webkit-appearance: none;
      -moz-appearance: none;
      position: relative;
      height: 15px;
      width: 15px;
      outline: none;
      border: 0;
      margin: 0 15px 0 0;
      cursor: pointer;
      background: var(--background);
      display: grid;
      align-items: center;
      margin-right: 20px;
    }
  
    > input[type='checkbox']::before,
    > input[type='checkbox']::after {
      content: '';
      position: absolute;
      height: 2px;
      top: auto;
      background: ${props => props.theme.colors.tertiary};
      border-radius: 2px;
    }
  
    > input[type='checkbox']::before {
      width: 0px;
      right: 60%;
      transform-origin: right bottom;
    }
  
    > input[type='checkbox']::after {
      width: 0px;
      left: 40%;
      transform-origin: left bottom;
    }
  
    > input[type='checkbox']:checked::before {
      animation: check-01 0.4s ease forwards;
    }
  
    > input[type='checkbox']:checked::after {
      animation: check-02 0.4s ease forwards;
    }
  
    > input[type='checkbox']:checked + label {
      color: ${props => props.theme.colors.muted};
      animation: move 0.3s ease 0.1s forwards;
    }
  
    > input[type='checkbox']:checked + label::before {
      background: ${props => props.theme.colors.muted};
      animation: slice 0.4s ease forwards;
    }
  
    > input[type='checkbox']:checked + label::after {
      animation: firework 0.5s ease forwards 0.1s;
    }
  
    @keyframes move {
      50% {
        padding-left: 8px;
        padding-right: 0px;
      }
  
      100% {
        padding-right: 4px;
      }
    }
  
    @keyframes slice {
      60% {
        width: 100%;
        left: 4px;
      }
  
      100% {
        width: 100%;
        left: -2px;
        padding-left: 0;
      }
    }
  
    @keyframes check-01 {
      0% {
        width: 4px;
        top: auto;
        transform: rotate(0);
      }
  
      50% {
        width: 0px;
        top: auto;
        transform: rotate(0);
      }
  
      51% {
        width: 0px;
        top: 8px;
        transform: rotate(45deg);
      }
  
      100% {
        width: 5px;
        top: 8px;
        transform: rotate(45deg);
      }
    }
  
    @keyframes check-02 {
      0% {
        width: 4px;
        top: auto;
        transform: rotate(0);
      }
  
      50% {
        width: 0px;
        top: auto;
        transform: rotate(0);
      }
  
      51% {
        width: 0px;
        top: 8px;
        transform: rotate(-45deg);
      }
  
      100% {
        width: 10px;
        top: 8px;
        transform: rotate(-45deg);
      }
    }
  
    @keyframes firework {
      0% {
        opacity: 1;
        box-shadow: 0 0 0 -2px ${props => props.theme.colors.tertiary}, 0 0 0 -2px ${props => props.theme.colors.tertiary}, 0 0 0 -2px ${props => props.theme.colors.tertiary},
          0 0 0 -2px ${props => props.theme.colors.tertiary}, 0 0 0 -2px ${props => props.theme.colors.tertiary}, 0 0 0 -2px ${props => props.theme.colors.tertiary};
      }
  
      30% {
        opacity: 1;
      }
  
      100% {
        opacity: 0;
        box-shadow: 0 -15px 0 0px ${props => props.theme.colors.tertiary}, 14px -8px 0 0px ${props => props.theme.colors.tertiary},
          14px 8px 0 0px ${props => props.theme.colors.tertiary}, 0 15px 0 0px ${props => props.theme.colors.tertiary}, -14px 8px 0 0px ${props => props.theme.colors.tertiary},
          -14px -8px 0 0px ${props => props.theme.colors.tertiary};
      }
    }
  }

  > footer {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }

`;

export const ButtonRemove = styled.button`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  cursor: pointer;
  display: flex;
  background: transparent;
  border: none;
  z-index: 9;
  color: ${props => props.theme.colors.white};
`;

interface IBtnToggleProps {
  className?: string;
  badgeValue?: number;
}

export const BtnToggle = styled.h5<IBtnToggleProps>`
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  user-select: none;
  white-space: nowrap;
  cursor: pointer;
  font-size: 10px;
  transition: all 0.25s ease-in-out;
  flex-direction: column;
  text-transform: uppercase;
  padding: 0 0.75rem;

  &:before {
    content: '${props => props.badgeValue}';
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff50;
    border: 1px solid ${props => props.theme.cards.border};
    backdrop-filter: blur(5px); 
    color: ${props => props.theme.colors.white};
    border-radius: 50%;
    height: 18px;
    width: 18px;
    font-size: 11px;
    right: 9px;
    bottom: 16px;
    transition: all 0.25s ease-in-out;
  }

  &.last {

    &:before {
      right: 22px;
    }
  }

  &:hover {
    color: ${props => props.theme.colors.primary};
  }
  
  &.current {
    color: ${props => props.theme.colors.primary};
    
    &:before {
      background: ${props => props.theme.colors.primary};
      color: ${props => props.theme.colors.dark};
    }
  }
`;